import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';
import DateTimeUtils from 'js/utils/DateTimeUtils';

import { useIsWeekToModuleEnabledForCourse } from 'bundles/custom-labels/utils/featureFlags';
import Notification from 'bundles/notification-center/components/Notification';
import type {
  DeadlineReminderNotification as DeadlineReminderNotificationType,
  Notification as NotificationType,
} from 'bundles/notification-center/types';

import _t from 'i18n!nls/notification-center';

type Props = {
  notification: DeadlineReminderNotificationType;
  rank?: number;
  onClick: (notification: NotificationType) => void;
};

const DeadlineReminderNotification = ({
  rank,
  notification,
  notification: {
    data: { deadline, weekNumber, course, assignments },
  },
  onClick,
}: Props) => {
  let href = '';

  const isWeekToModuleEnabledForCourse = useIsWeekToModuleEnabledForCourse(course.id);

  if (assignments.length === 1) {
    const assignment = assignments[0];
    // @ts-expect-error TS18048 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
    href = `/learn/${course.slug}/${assignment.typeName}/${assignment.id}`;
  } else if (isWeekToModuleEnabledForCourse) {
    href = `/learn/${course.slug}/home/module/${weekNumber}`;
  } else {
    href = `/learn/${course.slug}/home/week/${weekNumber}`;
  }

  const formattedDeadline = DateTimeUtils.momentWithUserTimezone(deadline).format('dddd MMM D');

  return (
    <Notification href={href} notification={notification} rank={rank} onClick={onClick}>
      <FormattedHTMLMessage
        message={_t(
          `{assignmentCount} {assignmentCount, plural, one {assignment deadline} other {assignment deadlines}} 
          coming up in <strong>{courseName}</strong>. Finish before {formattedDeadline}.`
        )}
        assignmentCount={assignments.length}
        courseName={course.name}
        formattedDeadline={formattedDeadline}
        tagName="span"
      />
    </Notification>
  );
};

export default DeadlineReminderNotification;
